$(document).ready(function () {
 
  $('.coll-filter, #sort-by').niceSelect();



  $('.popup-opener').click(function(e){
    //alert('alert');
    e.preventDefault();
    var $parents = $(this).attr('data-popup-id');
    var $customPop = $(this).attr('data-overlay');
    $("div[data-popup='" + $parents + "']").addClass("active");
    if($customPop !== "false"){$('.overlay').addClass("active");}
    $("div[data-popup='" + $parents + "']").siblings(".cs-popup").removeClass("active");
    $(this).addClass("active");
  });

  $('.close-icon').click(function(e){
    e.preventDefault();
    var $parents = $('.active').attr('data-popup');
    $(this).closest(".cs-popup").removeClass("active");
    $('.overlay').removeClass("active");
    $('.popup-opener').removeClass("active");
  });


  $('.overlay').click(function(e){
    e.preventDefault();
    var $parents = $('.active').attr('data-popup');
    $('.cs-popup').removeClass('active');
    $('.overlay').removeClass("active");
    $('.popup-opener').removeClass("active");
  });

  $(document).keyup(function(e) {
    if (e.keyCode == 27) {
      $(".cs-popup").removeClass("active");
      $('.overlay').removeClass("active");
      $('.popup-opener').removeClass("active");
    }
  });





  $('.text-advert-section .flexbox, .adverts-section .flexbox').slick({  
    dots: false,
    arrows: false,
    infinite: true,
    speed: 300,
    autoplay: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.toggle').click(function(e) {	

    var $this = $(this);

    if ($this.next().hasClass('show')) {
      $this.next().removeClass('show');
      $this.next().slideUp(350);
      $this.removeClass('active');

    } else {
      $this.parent().parent().find('li .inner').removeClass('show');
      $this.parent().parent().find('li .inner').slideUp(350);
      $this.next().toggleClass('show');
      $this.next().slideToggle(350);
      $this.addClass('active'); 
    }
  });


  $(".edit-address .btn").click(function(){
    $(".edit-address-form").slideToggle();
  });

  $('body.template-cart').on('click', '.qur-icon', function(){
    var ip = parseInt($(this).parent().find('input').val());
    if($(this).hasClass('plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      ip = 1;
    }
    $(this).parent().find('input').val(ip);
  });


  if ($(window).width() < 992) {
    $(".collection-sidebar--section h4").click(function(){
      $(this).next().slideToggle();
      $(this).toggleClass("active");
    });
  }

 


});
